import SEO from "@/components/SEO";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const GROUPS = [
  {
    title: "Ordering",
    items: [
      { q: "How do I place an order?", a: "Add products to your cart, click Checkout, enter your email and pay securely with Stripe or PayPal. You will receive an order confirmation email within seconds." },
      { q: "Can I change or cancel my order?", a: "Reach out within 2 hours of placing your order and we will do our best. Once fulfillment starts we cannot cancel, but you can still return within 30 days." },
      { q: "Do you offer discounts for bulk orders?", a: "Yes — email support@creatormicpro.com with your quantity and we will send you a custom quote." },
    ],
  },
  {
    title: "Shipping",
    items: [
      { q: "How fast do you ship?", a: "US orders are dispatched within 24 hours. Standard delivery is 3–5 business days. Free shipping over $50." },
      { q: "Do you ship internationally?", a: "Yes — to 40+ countries. International rates and estimated delivery are shown at checkout." },
      { q: "How do I track my order?", a: "You will receive a tracking number by email as soon as the package leaves our warehouse. You can also use our Track order page any time." },
    ],
  },
  {
    title: "Returns & Warranty",
    items: [
      { q: "What is your return policy?", a: "30-day risk-free returns. Return shipping is free within the US. Any product, any reason." },
      { q: "How does the 2-year warranty work?", a: "Every CreatorMic Pro product is warrantied against manufacturing defects for 2 years from purchase. Email support with your order number and we will replace the item." },
    ],
  },
  {
    title: "Product & Compatibility",
    items: [
      { q: "Which phones are supported?", a: "Every wireless kit ships with USB-C, Lightning, and 3.5mm adapters — so your mic works with any iPhone (Lightning or USB-C), iPad, Android phone, or DSLR camera out of the box." },
      { q: "What is the wireless range?", a: "Solo Wireless: 40m line-of-sight. Pro Wireless Duo: 60m line-of-sight." },
      { q: "How long does the battery last?", a: "Solo: 6 hours. Pro Duo: 8 hours per transmitter, 24 hours total with the charge case." },
      { q: "Do I need an app?", a: "No. Plug in the receiver, clip on the transmitter, and hit record. Everything runs on-device." },
    ],
  },
];

export default function FAQ() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: GROUPS.flatMap((g) => g.items).map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
  return (
    <div className="fade-in" data-testid="page-faq">
      <SEO title="Frequently asked questions" description="Answers about ordering, shipping, returns, and compatibility." path="/faq" jsonLd={jsonLd} />
      <section className="max-w-4xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-20">
        <p className="eyebrow mb-4">Help center</p>
        <h1 className="text-h1 text-[#1D1D1F]">Frequently asked questions.</h1>
        <p className="mt-6 text-[#86868B] max-w-2xl">Cannot find what you are looking for? Email support@creatormicpro.com — we typically reply within a few hours.</p>

        <div className="mt-14 space-y-10">
          {GROUPS.map((g) => (
            <div key={g.title}>
              <h2 className="text-h3 text-[#1D1D1F] mb-4">{g.title}</h2>
              <Accordion type="single" collapsible className="space-y-3">
                {g.items.map((it) => (
                  <AccordionItem key={`${g.title}-${it.q}`} value={`${g.title}-${it.q}`} className="bg-[#F5F5F7] rounded-2xl px-6 border-0">
                    <AccordionTrigger className="text-left font-display text-base hover:no-underline">{it.q}</AccordionTrigger>
                    <AccordionContent className="text-[#86868B]">{it.a}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
